import axiosInstance from "@/services/axiosInstance";
import type {
    Note,
    PaginatedNoteList,
    PatchedNote,
} from "@/types/api/data-contracts";
import type { AxiosPromise } from "axios";

export interface NoteCreatePayload {
    body: string;
    is_pinned?: boolean;
    target_type: string;
    target_uuid: string;
}

class NoteService {
    // eslint-disable-next-line no-use-before-define
    private static instance: NoteService;

    public static getInstance(): NoteService {
        if (!NoteService.instance) {
            NoteService.instance = new NoteService();
        }
        return NoteService.instance;
    }

    listEntityNotes(params: {
        target_type: string;
        target_uuid: string;
    }): AxiosPromise<PaginatedNoteList> {
        return axiosInstance.get("notes/", { params });
    }

    getEntityNote(noteUuid: string): AxiosPromise<Note> {
        return axiosInstance.get(`notes/${noteUuid}/`);
    }

    createEntityNote(payload: NoteCreatePayload): AxiosPromise<Note> {
        return axiosInstance.post("notes/", payload);
    }

    updateEntityNote(
        noteUuid: string,
        payload: PatchedNote
    ): AxiosPromise<Note> {
        return axiosInstance.patch(`notes/${noteUuid}/`, payload);
    }

    deleteEntityNote(noteUuid: string): AxiosPromise<void> {
        return axiosInstance.delete(`notes/${noteUuid}/`);
    }
}

export default NoteService;
